import {type GetterTree} from 'vuex';

const getters: GetterTree<NotificationState, RootState> = {
    unreadMessages(state)
    {
        if (state.count > 999)
        {
            return '99+';
        }

        return state.count;
    },
    outdated(state)
    {
        return state.lastTimestamp < state.lastStorageTimestamp;
    },
    latestTimestamp(state)
    {
        return Math.max(state.lastStorageTimestamp, state.lastTimestamp);
    },
};

export default getters;